import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class DashboardDefaultGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<UrlTree> {
    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => {
        const availableSkins = Array.isArray(plan?.available_dashboard_skins)
          ? plan.available_dashboard_skins : [];
        const selectedSkin = ['logistics', 'tax_accountancy'].includes(plan?.default_skin) &&
          availableSkins.includes(plan.default_skin)
          ? plan.default_skin : null;
        return this.router.createUrlTree(
          [selectedSkin === 'tax_accountancy' ? '/dashboard/tax-accountancy' :
            selectedSkin === 'logistics' ? '/dashboard/logistics' : '/dashboard'],
          { queryParams: route.queryParams }
        );
      }),
      catchError(() => of(this.router.createUrlTree(['/dashboard'], { queryParams: route.queryParams })))
    );
  }
}
